import axios from 'axios'

export const API_BASE = 'https://geonode.qpark.io/api'

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000
})
